// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccessModal_overlay__XI4j4 {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
  animation: AccessModal_fadeIn__5vHFS 0.25s ease;
}

@keyframes AccessModal_fadeIn__5vHFS {
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.AccessModal_modal__YgV4x {
  background: #ffffff;
  width: 880px;
  max-width: 95vw;
  max-height: 85vh;
  overflow-y: auto;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  padding: 22px 24px;
  display: flex;
  flex-direction: column;
  font-family: system-ui, sans-serif;
  transition: all 0.3s ease;
}

.AccessModal_saving__-zusH {
  opacity: 0.8;
  pointer-events: none;
  filter: grayscale(0.5);
}

/* ---------- HEADER ---------- */
.AccessModal_header__J-bBI {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
  margin-bottom: 14px;
}

.AccessModal_header__J-bBI h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1a1a2e;
}

.AccessModal_routeInfo__\\+WtpE {
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
}

.AccessModal_iconAccent__lzlbo {
  color: #4a6cf7;
}

.AccessModal_closeBtn__JJ0QN {
  border: none;
  background: transparent;
  color: #666;
  font-size: 20px;
  cursor: pointer;
  transition: color 0.2s ease;
}
.AccessModal_closeBtn__JJ0QN:hover {
  color: #000;
}

/* ---------- SEARCH ---------- */
.AccessModal_searchBox__1eFig {
  margin: 6px 0 14px;
  position: relative;
  width: 100%;
}

.AccessModal_searchBox__1eFig input {
  width: 100%;
  box-sizing: border-box;
  padding: 9px 34px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 14px;
  outline: none;
  transition: border 0.2s ease, background 0.2s ease;
  background: #fafafa;
}
.AccessModal_searchBox__1eFig input:focus {
  border-color: #4a6cf7;
  background: #fff;
}
.AccessModal_icon__pu8ko {
  position: absolute;
  left: 10px;
  top: 10px;
  color: #888;
}

/* ---------- USER LIST ---------- */
.AccessModal_userList__4UqcC {
  flex: 1 1;
  overflow-y: auto;
  border-top: 1px solid #eee;
  padding-top: 10px;
}

.AccessModal_letterBlock__fqwzj {
  margin-bottom: 16px;
}

.AccessModal_letter__vn3ks {
  font-size: 15px;
  font-weight: 700;
  color: #4a6cf7;
  margin: 6px 0;
}

.AccessModal_letterUsers__7rRG6 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 6px;
}

.AccessModal_userItem__qF1HP {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border: 1px solid #d0d4e4;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #f9f9fb;
}

.AccessModal_userItem__qF1HP:hover {
  background: #eef2ff;
  border-color: #4a6cf7;
}

.AccessModal_hasAccess__r-sK1 {
  background: #eaf7f3; /* мягкий мятно-голубой фон */
  border: 1px solid #3ba27a; /* приятный мятный контур */
}

.AccessModal_hasAccess__r-sK1:hover {
  background: #e1f3ed;
}

.AccessModal_iconActive__ZYVe2 {
  color: #2b8061; /* приглушённый зелёно-бирюзовый */
}

/* ---------- SAVE BUTTON ---------- */
.AccessModal_saveBtn__7JjKh {
  margin-top: 16px;
  border: none;
  border-radius: 10px;
  padding: 10px 16px;
  background: #4a6cf7;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.25s ease;
}

.AccessModal_saveBtn__7JjKh:hover {
  background: #3d5be4;
}

.AccessModal_saved__yhm7t {
  background: #3ba27a !important; /* стильный бирюзово-мятный */
  color: #fff !important;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Dispatcher/AccessManagement/components/AccessModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+CAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,kDAAkD;EAClD,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA,oCAAoC;AACpC;EACE,SAAO;EACP,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB,EAAE,6BAA6B;EAClD,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE,kCAAkC;AACpD;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B,EAAE,6BAA6B;EAC7D,sBAAsB;AACxB","sourcesContent":[".overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.45);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 5000;\r\n  animation: fadeIn 0.25s ease;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.98);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.modal {\r\n  background: #ffffff;\r\n  width: 880px;\r\n  max-width: 95vw;\r\n  max-height: 85vh;\r\n  overflow-y: auto;\r\n  border-radius: 14px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\r\n  padding: 22px 24px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  font-family: system-ui, sans-serif;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.saving {\r\n  opacity: 0.8;\r\n  pointer-events: none;\r\n  filter: grayscale(0.5);\r\n}\r\n\r\n/* ---------- HEADER ---------- */\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  border-bottom: 1px solid #eee;\r\n  padding-bottom: 8px;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.header h3 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #1a1a2e;\r\n}\r\n\r\n.routeInfo {\r\n  font-size: 13px;\r\n  color: #666;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.iconAccent {\r\n  color: #4a6cf7;\r\n}\r\n\r\n.closeBtn {\r\n  border: none;\r\n  background: transparent;\r\n  color: #666;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  transition: color 0.2s ease;\r\n}\r\n.closeBtn:hover {\r\n  color: #000;\r\n}\r\n\r\n/* ---------- SEARCH ---------- */\r\n.searchBox {\r\n  margin: 6px 0 14px;\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.searchBox input {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  padding: 9px 34px;\r\n  border-radius: 8px;\r\n  border: 1px solid #ccc;\r\n  font-size: 14px;\r\n  outline: none;\r\n  transition: border 0.2s ease, background 0.2s ease;\r\n  background: #fafafa;\r\n}\r\n.searchBox input:focus {\r\n  border-color: #4a6cf7;\r\n  background: #fff;\r\n}\r\n.icon {\r\n  position: absolute;\r\n  left: 10px;\r\n  top: 10px;\r\n  color: #888;\r\n}\r\n\r\n/* ---------- USER LIST ---------- */\r\n.userList {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  border-top: 1px solid #eee;\r\n  padding-top: 10px;\r\n}\r\n\r\n.letterBlock {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.letter {\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  color: #4a6cf7;\r\n  margin: 6px 0;\r\n}\r\n\r\n.letterUsers {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\r\n  gap: 6px;\r\n}\r\n\r\n.userItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 7px 10px;\r\n  border: 1px solid #d0d4e4;\r\n  border-radius: 8px;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  background: #f9f9fb;\r\n}\r\n\r\n.userItem:hover {\r\n  background: #eef2ff;\r\n  border-color: #4a6cf7;\r\n}\r\n\r\n.hasAccess {\r\n  background: #eaf7f3; /* мягкий мятно-голубой фон */\r\n  border: 1px solid #3ba27a; /* приятный мятный контур */\r\n}\r\n\r\n.hasAccess:hover {\r\n  background: #e1f3ed;\r\n}\r\n\r\n.iconActive {\r\n  color: #2b8061; /* приглушённый зелёно-бирюзовый */\r\n}\r\n\r\n/* ---------- SAVE BUTTON ---------- */\r\n.saveBtn {\r\n  margin-top: 16px;\r\n  border: none;\r\n  border-radius: 10px;\r\n  padding: 10px 16px;\r\n  background: #4a6cf7;\r\n  color: #fff;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  transition: all 0.25s ease;\r\n}\r\n\r\n.saveBtn:hover {\r\n  background: #3d5be4;\r\n}\r\n\r\n.saved {\r\n  background: #3ba27a !important; /* стильный бирюзово-мятный */\r\n  color: #fff !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `AccessModal_overlay__XI4j4`,
	"fadeIn": `AccessModal_fadeIn__5vHFS`,
	"modal": `AccessModal_modal__YgV4x`,
	"saving": `AccessModal_saving__-zusH`,
	"header": `AccessModal_header__J-bBI`,
	"routeInfo": `AccessModal_routeInfo__+WtpE`,
	"iconAccent": `AccessModal_iconAccent__lzlbo`,
	"closeBtn": `AccessModal_closeBtn__JJ0QN`,
	"searchBox": `AccessModal_searchBox__1eFig`,
	"icon": `AccessModal_icon__pu8ko`,
	"userList": `AccessModal_userList__4UqcC`,
	"letterBlock": `AccessModal_letterBlock__fqwzj`,
	"letter": `AccessModal_letter__vn3ks`,
	"letterUsers": `AccessModal_letterUsers__7rRG6`,
	"userItem": `AccessModal_userItem__qF1HP`,
	"hasAccess": `AccessModal_hasAccess__r-sK1`,
	"iconActive": `AccessModal_iconActive__ZYVe2`,
	"saveBtn": `AccessModal_saveBtn__7JjKh`,
	"saved": `AccessModal_saved__yhm7t`
};
export default ___CSS_LOADER_EXPORT___;
